import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { serverURL } from "../components/networking";

const SHOW_LOGIN = 0;
const SHOW_REGISTER = 1;
const SHOW_RESET = 2;

export default function LoginPage() {
    const [register, setRegister] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(serverURL + "/api/check-web-session/", {
                withCredentials: true,
            })
            .then(function (response) {
                if (response.data.isAuthenticated) {
                    sessionStorage.setItem("user_id", response.data.user_id);
                    navigate("/home");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }, [navigate]);

    return (
        <div>
            <div className="login-left">
                <div>
                    <img src="/korotuIconWhite.svg" alt="Korotu Tech. Icon" />
                    <h4>Korotu</h4>
                </div>
                <h1>CarbonCruise</h1>
            </div>

            <div className="login-right">
                {register === SHOW_LOGIN ? (
                    <LoginForm
                        setRegister={setRegister}
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                    />
                ) : register === SHOW_REGISTER ? (
                    <RegisterForm
                        setRegister={setRegister}
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                    />
                ) : (
                    <ForgotPasswordForm
                        setRegister={setRegister}
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                    />
                )}
                <h5 className="error-message" style={{ color: "white" }}>
                    {errorMessage}
                </h5>
            </div>
        </div>
    );
}

function RegisterForm({ setRegister, navigate, setErrorMessage }) {
    const [email, setEmail] = useState("");

    function register(email) {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );

        axios
            .post(
                serverURL + "/api/user/register/",
                { email: email },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                if (response.status === 200) {
                    navigate("/confirm");
                    setErrorMessage("Successfully registered!");
                }
            })
            .catch(function (error) {
                console.log(error);
                setErrorMessage(error.response.data.message);
            });
    }

    return (
        <>
            <h2>Sign up for CarbonCruise</h2>
            <p>Email: </p>{" "}
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <button type="button" onClick={() => register(email)}>
                Register
            </button>
            <button
                type="button"
                className="signup-return"
                onClick={() => {
                    setErrorMessage("");
                    setRegister(SHOW_LOGIN);
                }}
            >
                Return to Sign In
            </button>
        </>
    );
}

function LoginForm({ setRegister, navigate, setErrorMessage }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    function login(email, password) {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );
        setErrorMessage("");
        axios
            .post(
                serverURL + "/api/user/login/",
                { email: email, password: password },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                sessionStorage.setItem("user_id", response.data.user.user_id);
                navigate("/home");
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setErrorMessage(
                    error.response
                        ? error.response.data.message
                        : "An unexpected error occurred",
                );
            });
    }

    return (
        <>
            <h2>Sign in to CarbonCruise</h2>
            <p>Email: </p>{" "}
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <p>Password: </p>{" "}
            <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <button type="button" onClick={() => login(email, password)}>
                Log In
            </button>
            <button
                type="button"
                onClick={() => {
                    setErrorMessage("");
                    setRegister(SHOW_RESET);
                }}
            >
                Forgot Password?
            </button>
            <div className="signup-block">
                <p>Don't Have an Account?</p>
                <button
                    type="button"
                    onClick={() => {
                        setErrorMessage("");
                        setRegister(SHOW_REGISTER);
                    }}
                >
                    Sign Up
                </button>
            </div>
        </>
    );
}

function ForgotPasswordForm({ setRegister, navigate, setErrorMessage }) {
    const [email, setEmail] = useState("");

    function requestPasswordReset(email) {
        if (email !== "") {
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            setErrorMessage("");
            axios
                .post(
                    serverURL + "/api/user/request-password-reset/",
                    { email: email },
                    {
                        withCredentials: true,
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    },
                )
                .then(function (response) {
                    console.log(response);
                    setErrorMessage(
                        "If an account is associated with this email, instructions to reset password will be sent.",
                    );
                    navigate("/reset");
                })
                .catch(function (error) {
                    console.log(error);
                    console.log(error.response);
                    setErrorMessage(error.response.data.message);
                });
        } else {
            setErrorMessage("Email field cannot be blank.");
        }
    }

    return (
        <>
            <h2>Forgot Password?</h2>
            <h5>
                Enter your email address to receive instructions on how to reset
                your password
            </h5>
            <p>Email: </p>{" "}
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <button type="button" onClick={() => requestPasswordReset(email)}>
                Submit
            </button>
            <button
                type="button"
                className="signup-return"
                onClick={() => {
                    setErrorMessage("");
                    setRegister(SHOW_LOGIN);
                }}
            >
                Return to Sign In
            </button>
        </>
    );
}
